import { LayoutGrid } from "lucide-react";
import { iconForOverviewCard } from "./overviewSidebarIcons";
import {
  activeMatchPathsForCard,
  overviewSectionSidebarId,
  resolveActiveOverviewSection,
} from "./analytics/overviewHubUtils";

/**
 * Workspace / partner sidebar: Overview + submenu for the active overview section.
 */
function normalizePath(path) {
  return String(path || "").replace(/\/$/, "");
}

export function buildOverviewFirstSidebarItems(portal, pathname, permissionService) {
  const base =
    portal === "workspace"
      ? "/nyafaz-ep/workspace"
      : portal === "executive"
        ? "/nyafaz-ep/executive"
        : "/nyafaz-ep/partner";
  const onMainOverviewHub = normalizePath(pathname) === `${base}/overview`;
  const items = [
    {
      key: "overview",
      sectionId: "overview",
      IconComponent: LayoutGrid,
      label: onMainOverviewHub ? "Overview" : "Back to main",
      to: `${base}/overview`,
      exactActive: true,
    },
  ];

  const activeSection = resolveActiveOverviewSection(portal, pathname, permissionService);
  if (!activeSection?.cards?.length) {
    return items;
  }

  const sectionId = overviewSectionSidebarId(activeSection.id);

  activeSection.cards.forEach((card) => {
    items.push({
      key: `${activeSection.id}-${card.id}`,
      sectionId,
      IconComponent: iconForOverviewCard(activeSection.id, card.id),
      label: card.title,
      to: card.path,
      activeMatchPaths: activeMatchPathsForCard(portal, card),
    });
  });

  return items;
}
